import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {SummaryFieldModule} from '../../../../../../core/component/summary-field/summary-field.module';
import {UserSummaryFieldComponent} from './user-summary-field.component';
import {UserAvatarModule} from "../user-avatar/user-avatar.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SummaryFieldModule,
        UserAvatarModule,
    ],
    declarations: [
        UserSummaryFieldComponent,
    ],
    exports: [
        UserSummaryFieldComponent
    ],
})
export class UserSummaryFieldModule {
}